var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2617 0.767578H6.73828C3.02279 0.767578 0 3.79037 0 7.50586V15.709C0 19.1267 2.5575 21.9583 5.85938 22.3902V28.3551C5.85937 28.5289 5.91091 28.6989 6.00748 28.8434C6.10406 28.988 6.24133 29.1006 6.40193 29.1671C6.56254 29.2337 6.73926 29.2511 6.90976 29.2172C7.08026 29.1832 7.23687 29.0995 7.35979 28.9766L13.8891 22.4473H23.2617C26.9772 22.4473 30 19.4245 30 15.709V7.50586C30 3.79037 26.9772 0.767578 23.2617 0.767578ZM28.2422 15.709C28.2422 18.4552 26.0079 20.6895 23.2617 20.6895H13.525C13.2919 20.6895 13.0683 20.782 12.9035 20.9469L7.61719 26.2333V21.5684C7.61719 21.083 7.22367 20.6895 6.73828 20.6895C3.99205 20.6895 1.75781 18.4553 1.75781 15.709V7.50592C1.75781 4.75969 3.99205 2.52545 6.73828 2.52545H23.2617C26.0079 2.52545 28.2422 4.75969 28.2422 7.50592V15.709Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 7.14258H7.6333C7.14791 7.14258 6.75439 7.53609 6.75439 8.02148C6.75439 8.50687 7.14791 8.90039 7.6333 8.90039H22.3672C22.8526 8.90039 23.2461 8.50687 23.2461 8.02148C23.2461 7.53609 22.8527 7.14258 22.3672 7.14258ZM22.3672 10.6582H7.6333C7.14791 10.6582 6.75439 11.0517 6.75439 11.5371C6.75439 12.0225 7.14791 12.416 7.6333 12.416H22.3672C22.8526 12.416 23.2461 12.0225 23.2461 11.5371C23.2461 11.0517 22.8527 10.6582 22.3672 10.6582ZM16.2034 14.1738H7.6333C7.14791 14.1738 6.75439 14.5673 6.75439 15.0527C6.75439 15.5381 7.14791 15.9316 7.6333 15.9316H16.2034C16.6888 15.9316 17.0823 15.5381 17.0823 15.0527C17.0823 14.5673 16.6888 14.1738 16.2034 14.1738Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.5901695af1a3699896b1586828487fc1.svg";
export { ForwardRef as ReactComponent };